<div class="right-side p-5">
  <div class="section">
    <form [formGroup]="eventMarkAttendanceForm">
      <div class="card mb-3">
        <div class="card mb-3">
          <div class="card-header"><h2 class="text-start">Upload Attendance Mark:</h2></div>
          <div class="card-body">



            <div class="table-responsive">
              <table class="table table-striped table-bordered table-hover" style="font-size:9.5pt">
                <thead>
                  <tr>
                    <th>Sr. No.</th>

                    <th>Udyam Registration Number</th>
                    <!--<th>Participant Name</th>-->
                    <th>Name Of Enterprise</th>
                    <th>Participant Name</th>
                    <th>Participant's Mobile Number</th>
                    <th>Enrollment Id</th>
                    <th>Is Checked</th>
                  </tr>
                </thead>
                <!--<tbody>
        <tr *ngFor="let item of reportData; let i = index">
          <td>{{ i + 1 }}</td>

          <td>{{ item.UdyamRegistrationNumber }}</td>
          <td>{{ item.ParticipantName }}</td>
          <td>{{ item.NameOfEnterprise }}</td>
        </tr>
      </tbody>-->
                <tbody>
                  <tr *ngFor="let item of reportData; let i = index">

                    <td>{{ i + 1 }}</td>
                    <td>{{ item.UdyamRegistrationNumber }}</td>
                    <!--<td>{{ item.ParticipantName }}</td>-->
                    <td>{{ item.NameOfEnterprise }}</td>
                    <td>{{ item.ParticipantName }}</td>
                    <td>{{ item.MobileNumber }}</td>
                    <td>{{ item.EnrollmentId }}</td>
                    <td>
                      <input type="checkbox"
                             [value]="item.UdyamRegistrationNumber"
                             [checked]="item.IsChecked"
                             (change)="onCheckboxChange($event, item)">
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
            <!--<div *ngIf="showNoParticipantsMessage" class="text-center p-3">
    <input type="checkbox"  value="" id="declarion" formControlName="declarationAccepted" required/>
    <label class="ms-2" style="color: red; font-weight: bold;">
      Since there are no enrolled participants so Attendance cannot be marked.
    </label>
  </div>-->

            <div *ngIf="showNoParticipantsMessage" class="text-center p-3 border rounded mb-3 bg-light">
              <div class="form-check d-flex justify-content-center align-items-center">
                <input type="checkbox"
                       class="form-check-input"
                       id="declarationCheckbox"
                       formControlName="declarationAccepted" />
                <label class="form-check-label ms-2" for="declarationCheckbox" style="color: red; font-weight: bold;">
                  Since there are no enrolled participants, attendance cannot be marked. I confirm this status.
                </label>
              </div>

              <div *ngIf="eventMarkAttendanceForm.get('declarationAccepted')?.invalid && eventMarkAttendanceForm.get('declarationAccepted')?.touched"
                   class="text-danger small mt-1">
                You must check this box to confirm no participants are present.
              </div>
            </div>

            <div class="text-center">
              <button type="submit" class="btn btn-success me-2" (click)="onSubmit('draft')" [disabled]="showNoParticipantsMessage">Save as Draft</button>
              <button type="submit" class="btn btn-success me-2" (click)="onSubmit('submit')">Submit</button>
              <!-- <button type="submit" class="btn btn-success me-2" (click)="confirmSubmit()">Submit</button>-->
              <button id="btncancel" type="reset" class="btn btn-info" [routerLink]="'/view_event'">Back</button>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>
</div>
